export default "__VITE_ASSET___QhfNyqF__"